import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "py-8 px-14 bg-gray-100 border-t border-gray-300 flex items-center flex-col text-black w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center sm:justify-start" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "cursor-pointer",
    href: "/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "flex h-12",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "mr-4 cursor-pointer text-sm hover:underline",
    href: "/visitenkarte"
  }, "Businesscard")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "mr-4 cursor-pointer text-sm hover:underline",
    href: "/datenschutz"
  }, "Dataprotection")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "mr-4 cursor-pointer text-sm hover:underline",
    href: "/agb"
  }, "GTC / AGB")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "mr-4 cursor-pointer text-sm hover:underline",
    href: "/impressum"
  }, "Imprint")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "hover:underline cursor-pointer",
  href: "./"
}, "DB-ITSolutions", -1)

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'footer-item',
  props: {
    scrollY: Number
},
  setup(__props) {

const props = __props;

const editCookieSettings = () => {
    //
}

const cookiecomply = ref()

// eslint-disable-next-line no-undef


const cr = `Copyright © ${new Date().getFullYear()} `




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", { class: "w-full max-w-6xl sm:flex justify-center sm:justify-between items-center mb-8" }, [
      _hoisted_2,
      _createElementVNode("ul", { class: "flex flex-wrap justify-center sm:justify-end items-center mt-8 sm:mt-0" }, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "mr-4 cursor-pointer text-sm hover:underline",
            onClick: editCookieSettings
          }, "Cookie settings")
        ])
      ])
    ]),
    _createElementVNode("span", { class: "block text-sm text-center" }, [
      _createTextVNode(_toDisplayString(cr) + " "),
      _hoisted_7
    ])
  ]))
}
}

})